// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
async function fetchCartState() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    const cartData = await response.json();
    return cartData;
  } catch (error) {
    console.error("Error fetching cart:", error);
    throw error;
  }
}

// Function to check and update visibility of cross-sell items based on specific product names
async function updateCrossSellsVisibility() {
  try {
    const cart = await fetchCartState();
    // Extract "One-word Top/Bottom" names from cart items using regular expression
    const cartItemNames = cart.items
      .map((item) => {
        const matches = item.product_title.match(/\b\w+\s(Top|Bottom)\b/g);
        return matches ? matches : [];
      })
      .flat();


    // Find all cross-sell items in the DOM
    const crossSellItems = document.querySelectorAll("[data-name]");
    let allHidden = true;

    crossSellItems.forEach((item) => {
      const itemName = item.getAttribute("data-name");
      // Check if the item should be hidden based on cart items
      const shouldBeHidden = cartItemNames.some((cartItemName) =>
        itemName.includes(cartItemName)
      );

      // Hide the item if it matches any of the extracted names from the cart
      if (shouldBeHidden) {
        item.style.display = "none";
      } else {
        item.style.display = "";
        allHidden = false;
      }
    });

    // Hide the cross-sells section if all items are hidden
    const crossSellsSection = document.querySelector(".cross-sells");
    if (!crossSellsSection) return;
    if (allHidden) {
      crossSellsSection.style.display = "none";
    } else {
      crossSellsSection.style.display = "";
    }
  } catch (error) {
    console.error("Error updating cross-sells visibility:", error);
  }
}
(async () => {
  let cart = await fetchCartState();
  let watching_cart = false;

  if (cart.items.length > 0) {
    updateCrossSellsVisibility();
    setInterval(updateCrossSellsVisibility, 1000);
    watching_cart = true;
  }

  document.addEventListener("cart:item-added", function (evt) {
    if (!watching_cart) {
      setInterval(updateCrossSellsVisibility, 1000);
      watching_cart = true;
    }
    updateCrossSellsVisibility();
  });
})();

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
